__webpack_require__.p = "/RockPaperScissors/";